<div *ngIf="result_data" class="main_result bg-white">
    <table class="scenario_table name_table">
        <tr class="headers">
            <th *ngFor="let header of scenario_name_data.header_name">
                <span *ngIf="header != ''"> {{header}} </span>
                <span *ngIf="header == ''"> - </span>
            </th>
        </tr>
        <tr class="data" *ngFor="let data of scenario_name_data.header_data; let dataIndex = index">
            <td *ngFor="let key of data; let i = index" #tooltip="matTooltip" matTooltip={{key}} matTooltipPosition="below" matTooltipHideDelay="1"
            matTooltipClass="myTooltip" showIfTruncated>
                <span *ngIf="key != '' && i!=2" > {{key}} </span>
                <span *ngIf="key != '' && i==2" > {{new_pr_objective[key]}} </span>
                <div (click)="viewDetails(dataIndex)" *ngIf=" result_config.details && i == 0" class="view_details cursorPointer">View Details
                    <div>
                        <img src="./../../assets/images/scenario-comparison/double-arrow.svg">
                        <img src="./../../assets/images/scenario-comparison/double-arrow.svg">
                    </div>
                </div>
                <mat-icon class="info_icon cursorPointer" *ngIf="i == 2" (click)="getConstraintsDTO(dataIndex)" >info</mat-icon>
                <span *ngIf="key == ''"> - </span>
            </td>
        </tr>
    </table>
    <div class="meta-icon">
        <span>METADATA</span>
    </div>
    <table class="scenario_table">
        <tr class="headers">
            <th *ngFor="let header of scenario_id_data.header_name ; let i = index">
                <span *ngIf="header != ''"> {{statusHeaderCheck(header, i)}} </span>
                <span *ngIf="header == ''"> - </span>
            </th>
        </tr>
        <tr class="data" *ngFor="let data of scenario_id_data.header_data">
            <td *ngFor="let key of data ; let i = index">
                <span *ngIf="key != '' && i != statusIndex && i != dateIndex"> {{key}} </span>
                <span *ngIf="key != '' && i != statusIndex && i == dateIndex"> {{ key}} </span>
                <span *ngIf="key != '' && i == statusIndex && i != dateIndex"> {{statusText[key] | translate}} </span>
                <span *ngIf="key == ''"> - </span>
            </td>
        </tr>
    </table>
    <div class="note">
    <div class="meta-icon">
        <span>METRICS - PRICE BAND LEVEL</span>
    </div>
    <div  class="note-text font-md">
      <span>* Percentage | Absolute </span>
    </div>
    </div>
    <cdk-virtual-scroll-viewport itemSize="item_size" class="scenario_data_table">
        <table class="data_table">
            <tr *cdkVirtualFor="let result of scenario_result_data" class="data_headers">
                <th class="header_key">
                    <span *ngIf="result.Name!= ''"> {{result.Name}} </span>
                    <span *ngIf="result.Name == ''"> - </span>
                    <table class="scenario_table">
                        <tr class="headers">
                            <th *ngFor="let data_key of result.header">
                                <span *ngIf="data_key != ''"> {{data_key}} </span>
                                <span *ngIf="data_key == ''"> - </span>
                            </th>
                        </tr>
                        <tr class="data" *ngFor="let data of result.header_data">
                            <td *ngFor="let key of data">
                                <span class="percentage" *ngIf="!utilService.isNullOrEmptyOrUndefined(key) && !utilService.isNullOrEmptyOrUndefined(key[1]) && result?.Name?.toLowerCase() != store_key">{{priceMetricCalculationWithTwoDecimal(key[1])}}%</span>
                                <span class="percentage" *ngIf="!utilService.isNullOrEmptyOrUndefined(key) && !utilService.isNullOrEmptyOrUndefined(key[0]) && result?.Name?.toLowerCase() != store_key"> | {{priceMetricCalculationWithTwoDecimal(key[0])}}</span>
                                <span class="percentage" *ngIf="!utilService.isNullOrEmptyOrUndefined(key) && result?.Name?.toLowerCase() == store_key">{{key}}</span>
                                <span *ngIf="utilService.isNullOrEmptyOrUndefinedOrEmptyArray(key[0])"> - </span>
                            </td>
                        </tr>
                    </table>
                </th>
            </tr>
        </table>
    </cdk-virtual-scroll-viewport>
    <span> * {{"lang.scenario_comparison.duration_note" | translate}}</span>
</div>
<div class="main_result bg-white no-record" *ngIf="!result_data">
    <span>{{'lang.scenario_price_tier.no_record_found' | translate}}</span>
</div>

<!-- Objective Modal -->
<div class="backdrop" [ngClass]="{'d-none': !objective_flag, 'd-block': objective_flag}">
</div>
<div class="modal constraint_popup" tabindex="-1" role="dialog"
  [ngClass]="{'d-none': !objective_flag, 'd-block': objective_flag}">
  <!-- modal-dialog -->
  <div class="modal-dialog modal-dialog-centered" role="document">
    <!-- modal-content -->
    <div class="modal-content">

      <!-- modal-header -->
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="closePopup()"><span
            aria-hidden="true">&times;</span></button>
      </div>

      <!-- modal-body -->
      <div class="modal-body cancelBody">
        <h4 class="modal-title header_label_portal text-black mt-1 costa_text" *ngIf="objective_flag && data_source.data.length>0">
          {{"lang.new_price_recommender.constraints" | translate}}
        </h4>
        <div class="constraints-list-table" *ngIf="data_source.data.length>0">

            <!-- table viewport -->
            <cdk-virtual-scroll-viewport [tvsItemSize]="item_size" [ngStyle]="{'height.px': view_port_height }"
              class="wrapper mat-elevation-z2" #view_port>

              <table mat-table #table matSort [dataSource]="data_source">

                <!-- Constraint Type Column -->
                <ng-container matColumnDef="constraint_type">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.constraint_type" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row" class="center-align-text"> {{row.constraint_desc}} </td>
                </ng-container>

                <!-- Constraint Drill-Down Column -->
                <ng-container matColumnDef="constraint_drill">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.constraint_drill" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{ row.constraint_value }} </td>
                </ng-container>

                <!-- Minimum Value Column -->
                <ng-container matColumnDef="minimum_value">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.minimum_value" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{row.minimum_value}} </td>
                </ng-container>

                <!-- Maximum Value Column -->
                <ng-container matColumnDef="maximum_value">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.constraint_table_headers.maximum_value" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{row.maximum_value}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="constraint_table_columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: constraint_table_columns;"></tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>

        <h4 class="modal-title header_label_portal text-black mt-1 costa_text" *ngIf="objective_flag && data_source2.data.length>0">
          {{"lang.new_price_recommender.items_held" | translate}}
        </h4>
        <div class="items-list-table" *ngIf="data_source2.data.length>0">

            <!-- table viewport -->
            <cdk-virtual-scroll-viewport [tvsItemSize]="item_size" [ngStyle]="{'height.px': view_port_height }"
              class="wrapper mat-elevation-z2" #view_port2>

              <table mat-table #table matSort [dataSource]="data_source2">

                <!-- Product Category Column -->
                <ng-container matColumnDef="product_category">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.item_details_headeres.category" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row" class="center-align-text"> {{row.product_category}} </td>
                </ng-container>

                <!-- Products Column -->
                <ng-container matColumnDef="items">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.price_recommendation.item_details_headeres.product" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row"> {{ row.items }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="item_details_table_columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: item_details_table_columns;"></tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>


          <h4 class="modal-title header_label_portal text-black mt-1 costa_text" *ngIf="objective_flag && price_band_data_source.data.length>0">
            {{"lang.pricebandConfiguration.table_details.heading" | translate}}
          </h4>

          <div class="item-details-list-table" *ngIf="price_band_data_source.data.length>0">

            <!-- table viewport -->
            <cdk-virtual-scroll-viewport [tvsItemSize]="item_size" [ngStyle]="{'height.px': view_port_height }"
              class="wrapper mat-elevation-z2" #view_port3>

              <table mat-table #table matSort [dataSource]="price_band_data_source">
                <!-- Product Category Column -->
                <ng-container matColumnDef="product_category">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.pricebandConfiguration.table_details.spar_priceband" | translate}}

                  </th>
                  <td mat-cell *matCellDef="let row" class="center-align-text"> {{row.geo_desc}} </td>
                </ng-container>

                <!-- Products Column -->
                <ng-container matColumnDef="items">
                  <th mat-header-cell *matHeaderCellDef disableClear>
                    {{"lang.pricebandConfiguration.table_details.elasticity_price_band" | translate}} 

                  </th>
                  <td mat-cell *matCellDef="let row"> {{ row.geo_elasticity_desc }} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="item_details_table_columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: item_details_table_columns;"></tr>

              </table>
            </cdk-virtual-scroll-viewport>
          </div>

          
      </div>

      <!-- modal-footer -->
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>